import _ from "lodash";
/**-- external -- */
import React from "react";
import { Avatar } from "@toddle-edu/ds-web";

/**-- internal -- */
import { AVATAR_COLORS } from "Constants/colorConstants";
import { hashString } from "Utils";
import { getAcronym } from "Course/routes/Settings/modules/SettingsUtils";
import { getOutlinedIconComponent } from "Administrator/modules/Utils";

//TODO: Can we treat this as a pure UI component?
const CourseIcon = ({ course }) => {
  const { title } = course;

  const profileImageData = _.get(course, "profileImageData");

  const avatarColor =
    AVATAR_COLORS[hashString(course.id) % AVATAR_COLORS.length];

  const avatarElement = (
    <Avatar
      shade={"light"}
      color={avatarColor}
      name={getAcronym(title)}
      size={"x-small"}
      shape="square"
      dsVersion="2.0"
      src={profileImageData?.url}
    />
  );

  if (profileImageData?.icon) {
    const icon = getOutlinedIconComponent({
      icon: profileImageData.icon,
      size: "x-small",
    });

    if (icon) return icon;
  }
  return avatarElement;
};

export default CourseIcon;
